.emptyInfoMessage {
  border-radius: 2rem;
  margin-left: 0;
  margin-right: 0;
}

.goalCard {
  cursor: pointer;
  margin: 0 0 2rem;
  padding: 0.5rem 2rem;
}

.goalTitleRow {
  align-items: center;
  display: flex;
  gap: 0.75rem;
}

.goalMetaRow {
  align-items: center;
  display: flex;
}

.goalInfo {
  flex-grow: 1;
}

.sharedBy {
  font-size: 1.5rem;
  margin: 0;
  text-align: center;
}
